// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_page__CMgEM {
  width: 100vw;
  height: 100vh;
  background: rgb(247, 246, 255);
  color: rgb(255, 255, 255);
  margin: 0;
  padding-bottom: 80px;
  overflow-y: auto;
}

.style_section__7--NB {
  padding: 2px;
  border-radius: 10px;
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  margin-top: 100px;
}

.style_content__1mUN4 {
  display: flex;
  justify-content: space-between;
  background: rgb(255, 255, 255);
  align-items: center;
  border-radius: 10px;
  padding: 12px 20px;
  gap: 8px;
}
.style_content__title__-6-Lg {
  color: rgb(27, 27, 27);
  font-weight: 700;
  font-size: 2.4rem;
  max-width: 100px;
  text-align: center;
}
.style_content__description__qo\\+l2 {
  color: rgb(213, 212, 220);
  font-size: 1.4rem;
  font-weight: 500;
  margin: 16px 0;
  text-align: center;
}
.style_content__text__ZBtJf {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.style_content__text__week__48BC2 {
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  color: rgb(27, 27, 27);
  text-transform: uppercase;
}
.style_content__text__block__xx7pd {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
}
.style_content__text__block__xx7pd p {
  color: rgb(27, 27, 27);
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 14px;
}
.style_content__text__block__xx7pd h4 {
  color: rgb(27, 27, 27);
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 28px;
}

.style_clan__aURUm {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
}
.style_clan__image__8MDtI {
  width: 80px;
  height: 80px;
}
.style_clan__image__8MDtI img {
  width: 100%;
  height: 100%;
}
.style_clan__title__NO0T2 {
  font-weight: 700;
  color: rgb(27, 27, 27);
  font-size: 2.4rem;
}
.style_clan__members__0PMuW {
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
}
.style_clan__members__0PMuW i {
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,yBCDM;EDEN,SAAA;EACA,oBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,8BCnBM;EDoBN,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AADF;AAEE;EACE,sBC5BU;ED6BV,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,yBC/BS;EDgCT,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBCnDQ;EDoDR,yBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AADN;AAEM;EACE,sBC7DM;ED8DN,gBAAA;EACA,iBAAA;EACA,iBAAA;AAAR;AAEM;EACE,sBCnEM;EDoEN,gBAAA;EACA,iBAAA;EACA,iBAAA;AAAR;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAHF;AAIE;EACE,WAAA;EACA,YAAA;AAFJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAIE;EACE,gBAAA;EACA,sBC5FU;ED6FV,iBAAA;AAFJ;AAIE;EACE,sBChGU;EDiGV,iBAAA;AAFJ;AAGI;EACE,iBAAA;AADN","sourcesContent":["@import '../../../public/assets/colors';\n\n.page {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(247, 246, 255, 1);\n  color: $white;\n  margin: 0;\n  padding-bottom: 80px;\n  overflow-y: auto;\n}\n\n.section {\n  padding: 2px;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 350px;\n  margin: 0 auto;\n  margin-top: 100px;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  background: $white;\n  align-items: center;\n  border-radius: 10px;\n  padding: 12px 20px;\n  gap: 8px;\n  &__title {\n    color: $black-extra;\n    font-weight: 700;\n    font-size: 2.4rem;\n    max-width: 100px;\n    text-align: center;\n  }\n  &__description {\n    color: $light-grey;\n    font-size: 1.4rem;\n    font-weight: 500;\n    margin: 16px 0;\n    text-align: center;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    &__week {\n      font-size: 1.4rem;\n      font-weight: 700;\n      line-height: 14px;\n      text-align: center;\n      color: $black-extra;\n      text-transform: uppercase;\n    }\n\n    &__block {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      align-items: center;\n      p {\n        color: $black-extra;\n        font-weight: 500;\n        font-size: 1.4rem;\n        line-height: 14px;\n      }\n      h4 {\n        color: $black-extra;\n        font-weight: 700;\n        font-size: 2.4rem;\n        line-height: 28px;\n      }\n    }\n  }\n}\n\n.clan {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  &__image {\n    width: 80px;\n    height: 80px;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &__title {\n    font-weight: 700;\n    color: $black-extra;\n    font-size: 2.4rem;\n  }\n  &__members {\n    color: $black-extra;\n    font-size: 1.6rem;\n    i {\n      margin-right: 4px;\n    }\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `style_page__CMgEM`,
	"section": `style_section__7--NB`,
	"content": `style_content__1mUN4`,
	"content__title": `style_content__title__-6-Lg`,
	"content__description": `style_content__description__qo+l2`,
	"content__text": `style_content__text__ZBtJf`,
	"content__text__week": `style_content__text__week__48BC2`,
	"content__text__block": `style_content__text__block__xx7pd`,
	"clan": `style_clan__aURUm`,
	"clan__image": `style_clan__image__8MDtI`,
	"clan__title": `style_clan__title__NO0T2`,
	"clan__members": `style_clan__members__0PMuW`
};
export default ___CSS_LOADER_EXPORT___;
